export enum NotificationTypeEnum {
  SMART_METER_CREATED = 'SMART_METER_CREATED',
  FIRST_METER_DATA = 'FIRST_METER_DATA',
  ACTIVATE_READING_CONSENT = 'ACTIVATE_READING_CONSENT',
  REACTIVATE_READING_CONSENT = 'REACTIVATE_READING_CONSENT',
}
